module.exports = __webpack_public_path__ + "img/Tiny.5d976f58.png";